export const heroData = {
  name: "Yuvraj Bhullar",
  title: "Paralegal",
  pictureURL: "/images/profile.jpg",
  subtitle: "YOUR LEGAL NEEDS ARE OUR PRIORITY",
  altText: "Yuvraj Bhullar",
};
